import { bindActionCreators } from "redux";

export const NOTIFICATION_CALL_CANCEL = "NOTIFICATION_CALL_CANCEL";
export const NOTIFICATION_CALL = "NOTIFICATION_CALL";
export const NOTIFICATION_CALL_SUCCESS = "NOTIFICATION_CALL_SUCCESS";

const initialState = {
  notification: {
    anchorOrigin: { vertical: "top", horizontal: "right" },
    variant: "primary",
    open: false,
    message: "",
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_CALL_CANCEL:
      return {
        notification: {
          ...state.notification,
          open: false,
        },
      };

    // case auth.LOGIN_SUCCESS:
    // return {
    //     notification: {
    //         ...state.notification,
    //         anchorOrigin: { vertical: 'top', horizontal: 'right' },
    //         variant: 'error',
    //         open: true,
    //         message: 'Cuộc gọi tiếp theo'
    //     }
    // }

    default:
      return state;
  }
};

export const closeSnackbar = () => ({
  type: NOTIFICATION_CALL_CANCEL,
});

export const submitCall = () => ({
  type: NOTIFICATION_CALL_SUCCESS,
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeSnackbar,
      submitCall,
    },
    dispatch
  );
};
